export const GENERIC_ERROR_MSG = 'Try refreshing the page.';